import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '@dixa/lib-shared-habla';
import classNames from 'classnames';
import { usePublicElevioArticle } from '../../../../hooks/elevio/usePublicElevioArticle';
import { parseElevioArticleId } from './parseElevioArticleId';
import styles from './styles.module.scss';
export function LinkPreview({ className, articleUrl, }) {
    var _a, _b, _c, _d;
    const { data, isLoading } = usePublicElevioArticle({
        id: parseElevioArticleId(articleUrl),
    });
    if (isLoading || !data) {
        return null;
    }
    const linkPreviews = {
        headline: (_b = (_a = data.article) === null || _a === void 0 ? void 0 : _a.title) !== null && _b !== void 0 ? _b : '',
        description: (_d = (_c = data.article) === null || _c === void 0 ? void 0 : _c.category.title) !== null && _d !== void 0 ? _d : '',
    };
    return (_jsxs("a", Object.assign({ target: "_blank", rel: "noopener noreferrer", href: articleUrl, className: classNames(styles.linkPreviewContainer, className) }, { children: [_jsx(Text.Heading, Object.assign({ variant: "heading-3", color: "primary" }, { children: linkPreviews.headline })), _jsx(Text.Paragraph, Object.assign({ variant: "4", color: "secondary" }, { children: linkPreviews.description }))] })));
}
